import { getPrivacyPolicyEmbeddedLink } from '../../../OnboardTerms/StreamlineOnboardTerms/streamlineTermsEmbeddedLinks';

type privacyStatementsArray = Array<{ element: JSX.Element; key: string }>;

export const getPrivacyStatementLinks = (): privacyStatementsArray => {
  return [
    {
      element: getPrivacyPolicyEmbeddedLink({
        embeddedLinkText: 'terms.privacyStatement.personalData',
        flowType: 'signup',
        subPageAnchorNumber: 'collect-data',
      }),
      key: 'privacyStatement_2_personalData',
    },
    {
      element: getPrivacyPolicyEmbeddedLink({
        embeddedLinkText: 'terms.privacyStatement.purpose',
        flowType: 'signup',
        subPageAnchorNumber: 'process-data',
      }),
      key: 'privacyStatement_4_purpose',
    },
    {
      element: getPrivacyPolicyEmbeddedLink({
        embeddedLinkText: 'terms.privacyStatement.retentionPeriod',
        flowType: 'signup',
        subPageAnchorNumber: 'retain-data',
      }),
      key: 'privacyStatement_3_retentionPeriod',
    },
  ];
};
